import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import Image from "components/ui/Image"

function BIToolPoweredByApacheSupersetSection({ className }) {
  const { getAsset } = usePageAssets()
  const apacheSupersetItem1 = getAsset("product-apache-superset-item-1")
  const apacheSupersetItem2 = getAsset("product-apache-superset-item-2")
  const apacheSupersetItem3 = getAsset("product-apache-superset-item-3")
  return (
    <Container className={className} section>
      <Heading
        label="Open Analytics Platform"
        title="The easiest way to maintain Superset"
        subtitle={
          <>
            There is no need to install or maintain software with Preset. Get
            the latest version of Superset in a secure, reliable, and scalable
            SaaS experience—without the constraints of traditional BI tools.
          </>
        }
        decoration="border"
      />
      <div className="mt-12 grid grid-cols-1 gap-y-14 md:grid-cols-3 md:gap-x-10 lg:gap-x-12 xl:gap-x-20">
        <Item
          image={apacheSupersetItem1}
          title="Up-to-date Superset, always"
          description={
            <>
              Access all the latest features of Superset released and thoroughly
              tested every two weeks.
            </>
          }
        />
        <Item
          image={apacheSupersetItem2}
          title="One-click to deploy multiple workspaces"
          description={
            <>
              Give each team in your organization a separate Superset workspace
              to protect sensitive data.
            </>
          }
        />
        <Item
          image={apacheSupersetItem3}
          title="Control user roles and access"
          description={
            <>
              Easily assign roles and fine-tune data access using RBAC and
              row-level security (RLS).
            </>
          }
        />
      </div>
    </Container>
  )
}

function Item({ image, title, description }) {
  return (
    <div>
      <Image className="drop-shadow-panel" src={image} />
      <h3 className="mt-7 text-2xl font-bold text-black">{title}</h3>
      <p className="mt-2 text-base text-dark-grey">{description}</p>
    </div>
  )
}

export default BIToolPoweredByApacheSupersetSection
